/**
 * Navigation sub-FAB.
 *
 * Simple action-mode sub-FAB. Clicking triggers a side effect
 * (e.g. recompute itinerary, jump to the current itinerary target) via
 * the `onNavigate` callback. No MiniModal involved.
 */

import React from "react";
import currentLocation from "../../../../image/icons/floating/Navigation.svg";
import SubFloatingAction from "./SubFloatingAction";

/** Props exposed by the Navigate sub-FAB. */
export interface NavigateSubFloatingActionProps {

    /** Fired when the user clicks the sub-FAB. */
    "onNavigate": () => void;

    /** When `true`, use the dark palette variants. */
    "isDarkUi": boolean;
}

/**
 * Render the Navigate sub-FAB in pure action mode.
 *
 * @param props Component props. See `NavigateSubFloatingActionProps`.
 * @returns The configured `SubFloatingAction` that fires `onNavigate`.
 */
const NavigateSubFloatingAction: React.FC<NavigateSubFloatingActionProps> = ( {
    onNavigate,
    isDarkUi,
} ) => {
    return (
        <SubFloatingAction
            ariaLabel="Navigation"
            iconAlt="Navigation"
            iconSrc={currentLocation}
            isDarkUi={isDarkUi}
            kind="action"
            onAction={onNavigate}
        />
    );
};

export default NavigateSubFloatingAction;
